export const withLayout = (content, title = 'Sentinel Security') => `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>${title}</title>
  <style>
    body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; background-color: #f8fafc; margin: 0; padding: 0; }
    .wrapper { width: 100%; background-color: #f8fafc; padding: 40px 0; }
    .container { max-width: 600px; margin: 0 auto; background-color: #ffffff; border-radius: 8px; overflow: hidden; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06); }
    .header { background-color: #0f172a; padding: 24px; text-align: center; }
    .header h1 { color: #ffffff; margin: 0; font-size: 24px; letter-spacing: 0.5px; }
    .header img { margin-bottom: 12px; }
    .content { padding: 32px; color: #334155; line-height: 1.6; }
    .content h2 { color: #0f172a; font-size: 20px; margin-top: 0; }
    .button { display: inline-block; background-color: #0ea5e9; color: #ffffff; padding: 12px 24px; text-decoration: none; border-radius: 6px; font-weight: 600; margin: 24px 0; }
    .footer { background-color: #f1f5f9; padding: 24px; text-align: center; color: #64748b; font-size: 14px; }
    .highlight { background-color: #f1f5f9; padding: 12px; border-radius: 6px; font-family: monospace; display: inline-block; margin: 10px 0; font-size: 16px; letter-spacing: 1px; color: #0f172a;}
  </style>
</head>
<body>
  <div class="wrapper">
    <div class="container">
      <div class="header">
        <img src="https://sentinel.biscontractors.com/logo.svg" alt="Company Logo" height="40">
        <h1>Sentinel</h1>
      </div>
      <div class="content">
        ${content}
      </div>
      <div class="footer">
        <p>&copy; ${new Date().getFullYear()} Sentinel Security. All rights reserved.</p>
        <p>This is an automated message from your security awareness platform, please do not reply.</p>
      </div>
    </div>
  </div>
</body>
</html>
`;